module.exports = __webpack_public_path__ + "img/lu-video-poster.6cf0247b.jpg";